/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

export enum PlaybackErrorDataKey {
  /**
   * Playback error code
   */
  PLAYBACK_ERROR_CODE = 'error',
  /**
   * Playback error message
   */
  PLAYBACK_ERROR_MESSAGE = 'error_message',
  /**
   * Playback error description
   */
  PLAYBACK_ERROR_DESCRIPTION = 'error_description',
  /**
   * Playback internal error
   */
  PLAYBACK_ERROR_INTERNAL = 'error_internal',
}
